// client/src/pages/Home.js
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function Home() {
  const navigate = useNavigate();
  const { user } = useAuth();

  const [tasks, setTasks] = useState([]);
  const [collegeFilter, setCollegeFilter] = useState("all");
 
  const [loadingTasks, setLoadingTasks] = useState(true);
  const [filterType, setFilterType] = useState("all");

  const [showPostModal, setShowPostModal] = useState(false);
  const [posting, setPosting] = useState(false);

  const [newTask, setNewTask] = useState({
    title: "",
    description: "",
    category: "",
    budgetMin: "",
    budgetMax: "",
    dueDate: "",
    imageFile: null,
  });

  const [imagePreview, setImagePreview] = useState(null);

  const fetchTasks = async (type) => {
    try {
      setFilterType(type);
      //remove loading for toggle
     // setLoadingTasks(true);

      let query = "";

      if (type === "my" && user?.college) {
        query = `?college=${encodeURIComponent(user.college)}`;
      } else {
        query = "?college=all";
      }

      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/tasks${query}`
      );

      const data = await res.json();

      const now = new Date();
      const filtered = data.filter((task) => {
        const isExpired = task.dueDate && new Date(task.dueDate) < now;
        const hideStatuses = [
          "in_progress",
          "pending_completion",
          "completed",
          "expired",
        ];
        if (isExpired) return false;
        if (hideStatuses.includes(task.status)) return false;
        return true;
      });

      setTasks(filtered);
    } catch (err) {
      console.error("Fetch tasks error:", err);
    } finally {
      //setLoadingTasks(false);
    }
  };

  useEffect(() => {
    const initLoad = async () => {
      setLoadingTasks(true);
      if (user && user.college) {
        await fetchTasks("my");
      } else {
        await fetchTasks("all");
      }
      setLoadingTasks(false);
    };

    initLoad();
  }, [user]);


  const handleImageChange = (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setNewTask({ ...newTask, imageFile: f });
    setImagePreview(URL.createObjectURL(f));
  };

  const uploadImage = async () => {
    if (!newTask.imageFile) return "";
    const token = localStorage.getItem("cp_token");
    const fd = new FormData();
    fd.append("image", newTask.imageFile);

    const res = await fetch(`${process.env.REACT_APP_API_URL}/api/upload`, {
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      body: fd,
    });

    const data = await res.json();
    return res.ok ? data.url : "";
  };

  const postTask = async () => {
    if (posting) return;
    if (!user) return navigate("/login");

    const { title, description, category, budgetMin, budgetMax, dueDate } =
      newTask;

    if (
      !title ||
      !description ||
      !category ||
      !budgetMin ||
      !budgetMax ||
      !dueDate
    )
      return alert("Please fill all fields");

    setPosting(true);

    const imageUrl = await uploadImage();
    const token = localStorage.getItem("cp_token");

    const res = await fetch(`${process.env.REACT_APP_API_URL}/api/tasks`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        title,
        description,
        category,
        budgetMin,
        budgetMax,
        dueDate,
        imageUrl,
      }),
    });

    const d = await res.json();
    setPosting(false);

    if (!res.ok) return alert(d.error);

    const now = new Date();
    if (
      (!d.task.dueDate || new Date(d.task.dueDate) >= now) &&
      d.task.status !== "completed"
    ) {
      setTasks((p) => [d.task, ...p]);
    }

    setShowPostModal(false);
    setNewTask({
      title: "",
      description: "",
      category: "",
      budgetMin: "",
      budgetMax: "",
      dueDate: "",
      imageFile: null,
    });
    setImagePreview(null);
  };

  if (loadingTasks)
    return (
      <div className="text-center py-20 text-slate-600 dark:text-slate-300">
        Loading tasks…
      </div>
    );

  return (
    <div className="px-6 py-12 min-h-screen bg-slate-50 dark:bg-slate-900 transition overflow-x-hidden">
      <div className="text-center">
        <h1 className="text-5xl font-extrabold text-indigo-600 dark:text-indigo-400">
          CollegePal Tasks
        </h1>
        <p className="text-slate-600 dark:text-slate-400 mt-2 text-lg">
          Explore tasks posted by students across your campus.
        </p>
         
    <div className="mt-8 flex justify-center">
      <div className={`relative flex backdrop-blur-xl bg-white/20 dark:bg-white/10 border border-white/20 dark:border-white/10 rounded-full p-1 shadow-[inset_0_2px_4px_rgba(0,0,0,0.1)] overflow-hidden transition-all duration-500 ${
        user ? "w-[320px]" : "w-[170px]"
      }`}>

    {/* Sliding liquid background */}
    <div
      className={`absolute top-1 left-1 bottom-1 ${
        user ? "w-[calc(50%-4px)]" : "w-[calc(100%-8px)]"
      } rounded-full bg-gradient-to-r from-indigo-600 via-purple-600 to-indigo-600 
      shadow-lg shadow-indigo-500/30
      transition-all duration-700 ease-[cubic-bezier(0.22,1,0.36,1)]
      before:absolute before:inset-0 before:bg-white/20 before:blur-xl before:opacity-30
      ${
        filterType === "all"
          ? "translate-x-0"
          : "translate-x-full"
      }`}
    ></div>



        {/* All Colleges */}
        <button
          onClick={() => fetchTasks("all")}
          className={`relative z-10 ${
            user ? "w-1/2" : "w-full"
          } py-2 rounded-full font-medium transition-all duration-500 ease-in-out ${
            filterType === "all"
              ? "text-white"
              : "text-slate-700 dark:text-slate-200"
          }`}
        >
          All Colleges
        </button>

        {/* My College — Only if logged in */}
        {user && (
          <button
            onClick={() => fetchTasks("my")}
            className={`relative z-10 w-1/2 py-2 rounded-full font-medium transition-all duration-500 ease-in-out ${
              filterType === "my"
                ? "text-white"
                : "text-slate-700 dark:text-slate-200"
            }`}
          >
            My College
          </button>
        )}
      </div>
    </div>


        <div className="mt-6 flex items-center justify-center gap-4 flex-wrap max-w-full">
          <button
            onClick={() => navigate("/lost-found")}
            className="px-4 py-2 rounded-lg bg-indigo-500 text-white hover:bg-indigo-600 transition"
            style={{ height: 48, minWidth: 140 }}
          >
            Lost & Found
          </button>

          <button
            onClick={() => setShowPostModal(true)}
            className="px-10 py-3 text-lg font-semibold bg-gradient-to-r from-indigo-600 to-purple-600 text-white rounded-xl shadow-lg hover:scale-[1.03] transition max-w-full"
            style={{ minWidth: 280 }}
          >
            + Post a Task
          </button>

          <button
            onClick={() => navigate("/recruit")}
            className="px-4 py-2 rounded-lg bg-indigo-500 text-white hover:bg-indigo-600 transition"
            style={{ height: 48, minWidth: 140 }}
          >
            Recruit / Clubs
          </button>
        </div>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mt-12 max-w-full">
        {tasks.map((task) => (
          <div
            key={task._id}
            onClick={() => navigate(`/task/${task._id}`)}
            className="cursor-pointer bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-2xl shadow-md hover:shadow-xl transition p-5 hover:-translate-y-1"
          >
            {task.imageUrl && (
              <img
                src={task.imageUrl}
                className="w-full h-44 rounded-xl object-cover mb-4 shadow-sm"
                alt="task"
              />
            )}

            <h3 className="text-xl font-bold text-slate-900 dark:text-white">
              {task.title}
            </h3>

            <p className="text-slate-500 dark:text-slate-400 mt-1 text-sm">
              Budget: ₹{task.budgetMin} - ₹{task.budgetMax}
            </p>

            <p className="text-slate-400 dark:text-slate-500 text-xs mt-1">
              Due: {task.dueDate?.slice(0, 10)}
            </p>

            <span className="inline-block mt-3 px-3 py-1 text-sm rounded-lg bg-indigo-100 dark:bg-indigo-900/40 text-indigo-700 dark:text-indigo-300">
              {task.category}
            </span>
          </div>
        ))}

      {tasks.length === 0 && (
        <div className="text-center col-span-full mt-12">
          <p className="text-xl font-semibold text-slate-700 dark:text-slate-200">
            Be the first one to post 🚀
          </p>
          <p className="text-slate-500 dark:text-slate-400 mt-2">
            Or switch to "All Colleges" and explore what’s happening outside your campus.
            Maybe your next opportunity is waiting there 👀
          </p>
        </div>
      )}

      </div>

     {showPostModal && (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50 text-slate-900 dark:text-slate-100
">
          <div className="bg-white dark:bg-slate-800 p-6 rounded-2xl shadow-xl w-96 border border-slate-200 dark:border-slate-700">
            <h2 className="text-2xl font-bold text-slate-900 dark:text-white mb-4">Create New Task</h2>

            <div className="space-y-4">
              <input type="text" placeholder="Task Title" value={newTask.title} onChange={(e) => setNewTask({ ...newTask, title: e.target.value })} className="w-full p-2 rounded-lg border dark:border-slate-600 bg-white dark:bg-slate-700 text-slate-900 dark:text-white" />

              <textarea placeholder="Description" rows={3} value={newTask.description} onChange={(e) => setNewTask({ ...newTask, description: e.target.value })} className="w-full p-2 rounded-lg border dark:border-slate-600 bg-white dark:bg-slate-700" />

              <div className="grid grid-cols-2 gap-2">
                <input type="number" placeholder="Min Budget (₹)" value={newTask.budgetMin} onChange={(e) => setNewTask({ ...newTask, budgetMin: e.target.value })} className="p-2 rounded-lg border dark:border-slate-600 bg-white dark:bg-slate-700" />
                <input type="number" placeholder="Max Budget (₹)" value={newTask.budgetMax} onChange={(e) => setNewTask({ ...newTask, budgetMax: e.target.value })} className="p-2 rounded-lg border dark:border-slate-600 bg-white dark:bg-slate-700" />
              </div>

              <input type="date" value={newTask.dueDate} onChange={(e) => setNewTask({ ...newTask, dueDate: e.target.value })} className="w-full p-2 rounded-lg border dark:border-slate-600 
             bg-white dark:bg-slate-700 
             text-slate-900 dark:text-slate-100 
             dark:[color-scheme:dark]" />

              <select value={newTask.category} onChange={(e) => setNewTask({ ...newTask, category: e.target.value })} className="w-full p-2 rounded-lg border dark:border-slate-600 
             bg-white dark:bg-slate-700 
             text-slate-900 dark:text-slate-100">
                <option className="bg-white dark:bg-slate-800 text-slate-900 dark:text-slate-100" value="">Select Category</option>
                <option className="bg-white dark:bg-slate-800 text-slate-900 dark:text-slate-100" value="PPT">PPT</option>
                <option className="bg-white dark:bg-slate-800 text-slate-900 dark:text-slate-100" value="Drawing">Drawing</option>
                <option className="bg-white dark:bg-slate-800 text-slate-900 dark:text-slate-100" value="Assignment">Assignment</option>
                <option className="bg-white dark:bg-slate-800 text-slate-900 dark:text-slate-100" value="Design">Design</option>
                <option className="bg-white dark:bg-slate-800 text-slate-900 dark:text-slate-100" value="Event Help">Event Help</option>
                <option className="bg-white dark:bg-slate-800 text-slate-900 dark:text-slate-100" value="Technical Help">Technical Help</option>
                <option className="bg-white dark:bg-slate-800 text-slate-900 dark:text-slate-100" value="Other">Other</option>
              </select>

              <input type="file" onChange={handleImageChange} className="text-slate-900 dark:text-slate-100
             file:bg-slate-200 dark:file:bg-slate-700
             file:text-slate-900 dark:file:text-slate-100
             file:rounded-md file:border-0 file:px-3 file:py-1" />

              {imagePreview && <img src={imagePreview} className="w-full h-36 object-cover rounded-lg shadow" alt="preview" />}
            </div>

            <div className="mt-6 flex flex-col gap-3">
              <button onClick={postTask} disabled={posting} className="w-full py-2 rounded-lg text-white bg-indigo-600 hover:bg-indigo-700 shadow disabled:opacity-60">{posting ? "Posting..." : "Submit"}</button>
              <button onClick={() => setShowPostModal(false)} className="w-full py-2 rounded-lg bg-slate-200 dark:bg-slate-700 text-slate-700 dark:text-slate-300 hover:bg-slate-300 dark:hover:bg-slate-600">Cancel</button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}
